import { atlasRoutes } from "@/app/router/routes";
import { localStorageModule } from "@/modules/local-storage";

/**
 * Force a log-out.
 * (In the future, it could make sense to redirect to a page like "your session has expired", ...)
 */
export const forceLogOutNotAuthenticatedUser = async (): Promise<void> => {
  await localStorageModule.writePendingRedirectPath({
    pathname: location.pathname,
  });

  const logOutPath = atlasRoutes.logOut({}).path;

  /**
   * We use `window` directly (rather than useNavigate) because we don't have
   * access to react when we're calling this function.
   */
  window.location.assign(logOutPath);

  return;
};
